import { publish } from 'utils/subscriber';
import PUB_SUB_EVENTS from '../utils/consts';

export default () => {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.notification = document.querySelector('.added-to-cart-notification'); // Select the notification element

      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';

      this.header = document.querySelector('main-header'); // The header element that remains after scroll
      this.announcementBar = document.querySelector('.announcement-bar'); // The announcement bar element

      this.updateNotificationPosition(); // Set initial position

      window.addEventListener('scroll', this.updateNotificationPosition.bind(this)); // Update on scroll
    }

    fetchConfig(type = 'json') {
      return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
      };
    }

    engravingOption() {
      // mixed engraving part
      const engravingBlocks = document.querySelectorAll('.new-engraving');

      engravingBlocks.forEach((engravingBlock) => {
        const titleElement = engravingBlock.querySelector('.engraving-block__fields-box-title');
        const inputElements = engravingBlock.querySelectorAll('input[name="engraving_field"]');

        if (titleElement && inputElements.length > 0) {
          const propertyKey = titleElement.innerHTML.trim();

          const combinedValues = Array.from(inputElements)
            .map(input => input.value.trim())
            .filter(value => value !== "")
            .join('-');

          // Add as hidden input to the form
          if (propertyKey && combinedValues) {
            this.createHiddenInput(`properties[${propertyKey}]`, combinedValues);
          }
        }
      });
      // mixed engraving end

      const engravingBlock = document.querySelector('.engraving-block.active');
      if (!engravingBlock) return;

      const inputs = Array.from(engravingBlock.querySelectorAll('[name="engraving_field"]'))
        .filter(input => input.value.trim() !== '')
        .map(input => input.value.trim());

      if (inputs.length === 0) return;

      const select = engravingBlock.querySelector('[name="font"]');
      const selectVal = select ? select.value : '';

      if (select) {
        this.createHiddenInput('properties[FONT]', selectVal);
      }

      let engravingString = inputs.join('-');
      if (inputs.length === 1) {
        engravingString = `-${engravingString}`;
      }

      this.createHiddenInput('properties[INITIAL]', engravingString.toUpperCase());
    }

    createHiddenInput(name, value) {
      const hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = name;
      hiddenInput.value = value;
      if (this.form) {
        this.form.appendChild(hiddenInput);
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');

      const config = this.fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      this.engravingOption()

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      // eslint-disable-next-line
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          }

          if (!this.error) {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });

            // Dispatch a custom event with the cart data
            const cartUpdateEvent = new CustomEvent('cart-update', { detail: response });
            document.dispatchEvent(cartUpdateEvent);

            this.error = false;

            this.notification.classList.remove('hidden');
            setTimeout(() => {
              this.notification.classList.add('hidden');
            }, 1500);
          }
        })
        .catch((e) => {
          // eslint-disable-next-line
          console.error(e);
        })
        .finally(() => {
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper =
        this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    updateNotificationPosition() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const headerHeight = this.header ? this.header.offsetHeight : 0;
      const announcementHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0;

      if (scrollTop > announcementHeight) {
        this.notification.style.top = `${headerHeight}px`;
      } else {
        this.notification.style.top = `${announcementHeight + headerHeight}px`;
      }
    }
  }

  const init = () => {
    if (!customElements.get('product-form')) {
      customElements.define('product-form', ProductForm);
    }
  };
  init();
};
